"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInputWrapper = exports.StyledTitle = exports.StyledContent = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
exports.StyledContent = styled_components_1.default.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ theme, variant }) => (0, styled_components_1.css) `
    flex-direction: ${variant === 'default' ? 'column' : 'row-reverse'};
    gap: ${ui_common_components_1.utils.rem(theme.Spacing.Size.Small)};
    padding: ${variant === 'default' ? ui_common_components_1.utils.rem(theme.Spacing.Size.Small) : 0};
    border-radius: ${variant === 'default'
    ? ui_common_components_1.utils.rem(theme.Border.Radius.Large)
    : 0};
    background-color: transparent;
  `}
`;
exports.StyledTitle = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXXLarge)};
  justify-content: space-between;
`;
exports.StyledInputWrapper = styled_components_1.default.div `
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
`;
//# sourceMappingURL=Slider.styles.js.map